import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import DeleteIcon from 'mdi-react/DeleteIcon'
import React, { useCallback } from 'react'
import { useMutation } from 'react-query'
import { AsyncIconButton } from 'scenes/Dashboard/components-next/Button'
import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

import { useCorporateListViewStore } from '../CorporateListViewStore'
import { Corporate } from '../../../../../../../entities-next/corporate'

type DeleteCorporateButtonProps = {
  className: string
  corporate: Corporate
}

export function DeleteCorporateButton({ className, corporate }: DeleteCorporateButtonProps) {
  const { classes } = useStyles()
  const {
    actions: { deleteCorporate },
  } = useCorporateListViewStore()
  const { mutateAsync: handleCorporateDelete, status } = useMutation(deleteCorporate)
  const isLoading = status === 'loading'
  const handleClick = useCallback(() => handleCorporateDelete(corporate), [handleCorporateDelete, corporate])

  return (
    <BaseTooltip title="Delete user" bottom>
      <AsyncIconButton
        className={classNames(className, classes.iconContainer)}
        loading={isLoading}
        onClick={handleClick}
      >
        <DeleteIcon className={classes.fillParent} />
      </AsyncIconButton>
    </BaseTooltip>
  )
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  iconContainer: {
    width: spacing(4),
    height: spacing(4),
  },
  fillParent: {
    width: '100%',
    height: '100%',
  },
}))
